

<template>
    <div>
        <div class="col-xl-12 float-left background-fff mb-3 roi-widget padding15">
            <h6 class="proxima-nova-bold">Google Ads</h6>
            <span v-if="this.loading">Loading...</span>
            <span v-else>
                <a :href="`/googleads/domain/${this.order.domain ? this.order.domain.id : ''}`" target="_blank">{{enabled}}</a> enabled campaign(s)<br />
                <a :href="`/googleads/domain/${this.order.domain ? this.order.domain.id : ''}`" target="_blank">{{paused}}</a> paused campaign(s)
            </span>
        </div>
    </div>
</template>

<script>

export default {
    props: ['order'],
    data: function () {
        return {
            loading: false,
            taskStatuses: [0, 0, 0, 0, 0]
        };
    },
    mounted() {
        this.fetch();
    },
    watch: {

    },
    computed: {
        total(){
            return this.taskStatuses.reduce((a, b) => a + b, 0)
        },
        enabled(){
            return this.taskStatuses[2]
        },
        paused(){
            return this.taskStatuses[3]
        }
    },
    methods: {
        fetch() {
            this.loading = true;
            axios.get('/orders/' + this.order.id + '/google-ads-campaign-statuses').then((res) => {
                this.loading = false;
                this.taskStatuses = res.data;
            }).catch(e => {
                console.log(e);
            });
        },
    },
    filters: {

    }
}
</script>

<style scoped>

</style>
